import { useActionHandler, ActionHandlerOptions } from "./useActionHandler";
import {
  getOwnerSubscription,
  getOwnerPayments,
  getOwnerPaymentMethod,
  startOwnerSubscription,
  updateOwnerPaymentMethod,
  removeOwnerPaymentMethod,
  cancelOwnerSubscription,
  reactivateOwnerSubscription,
  getBillingProfile,
  saveBillingProfile,
} from "@/server-side/actions/ownerSubscription";
import { lookupCompanyByCui } from "@/server-side/actions/anaf";
import {
  StartSubscriptionRequest,
  CardSetupRequest,
  BillingProfileRequest,
} from "@/server-side/types/subscription";

export function useOwnerSubscriptionActions() {
  const { handleAction } = useActionHandler();

  return {
    getOwnerSubscription: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(getOwnerSubscription(venueId), options),

    getOwnerPayments: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(getOwnerPayments(venueId), options),

    getOwnerPaymentMethod: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(getOwnerPaymentMethod(venueId), options),

    startOwnerSubscription: (
      venueId: string,
      data: StartSubscriptionRequest,
      options?: ActionHandlerOptions
    ) => handleAction(startOwnerSubscription(venueId, data), options),

    updateOwnerPaymentMethod: (
      venueId: string,
      data: CardSetupRequest,
      options?: ActionHandlerOptions
    ) => handleAction(updateOwnerPaymentMethod(venueId, data), options),

    removeOwnerPaymentMethod: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(removeOwnerPaymentMethod(venueId), options),

    cancelOwnerSubscription: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(cancelOwnerSubscription(venueId), options),

    reactivateOwnerSubscription: (
      venueId: string,
      options?: ActionHandlerOptions
    ) => handleAction(reactivateOwnerSubscription(venueId), options),

    getBillingProfile: (venueId: string, options?: ActionHandlerOptions) =>
      handleAction(getBillingProfile(venueId), options),

    saveBillingProfile: (
      venueId: string,
      data: BillingProfileRequest,
      options?: ActionHandlerOptions
    ) => handleAction(saveBillingProfile(venueId, data), options),

    lookupCompanyByCui: (cui: string, options?: ActionHandlerOptions) =>
      handleAction(lookupCompanyByCui(cui), options),
  };
}
